import React from 'react'

const OurAssociateChannelPartners = () => {
    const associatobj = [
        {
            id:1,
            img:"assets/img/channel-partner/lawal.webp",
            heading:"Lawal Rahman Artbeat",
            span:"Nigeria",
        },
        {
            id:2,
            img:"assets/img/client-image/husan.webp",
            heading:"Hassan Rucyemangabo",
            span:"Rwanda",
        },
        {
            id:3,
            img:"assets/img/channel-partner/johann.webp",
            heading:"Johann Bain",
            span:"Bahamas",
        },
        {
            id:4,
            img:"assets/img/channel-partner/arun.webp",
            heading:"Arun Luthra",
            span:"Chandigarh",
        },
    ]
    return (
        <>
            <section className="bg-f9f6f6 channel-partner-area py-5">
                <div className="container-fluid pt-2">
                    <div className="section-title">
                        <h2>Our Associate Channel Partners</h2>
                        <div className="bar"></div>
                    </div>
                    <div className="row">
                        {associatobj.map((assocard)=> {
                            return  <div className="single-team" key={assocard.id}>
                                <div className="team-image">
                                    <img src={assocard.img} alt="" loading="lazy" />
                                </div>
                                <div className="team-content">
                                    <div className="team-info1">
                                        <h3>{assocard.heading}</h3>
                                        <span>{assocard.span}</span>
                                    </div>
                                </div>
                            </div>
                        
                        })}
                    </div>
                </div>
            </section>
        </>
    )
}

export default OurAssociateChannelPartners